module.exports = __webpack_public_path__ + "static/media/open-01.11183ed1.svg";